/* eslint react/display-name: 0 */
import React from 'react'
import PropTypes from 'prop-types'
import R from 'ramda'
import moment from 'moment'

import LineItem from '_views/lineItem'

const getMaxVersion = R.compose(
  R.toString,
  R.prop('max_version')
)
const getFreeUpgrade = R.compose(
  R.ifElse(
    R.equals('none'),
    R.always(null),
    R.identity
  ),
  R.defaultTo('none'),
  R.prop('free_upgrade')
)
const getSubEnd = R.compose(
  R.ifElse(
    R.isNil,
    R.always(null),
    x => moment(x).format('YYYY-MM-DD')
  ),
  R.prop('subscription_end')
)

const SerialInfo = ({
  serial = {}
}) => {
  return (
    <React.Fragment>
      <LineItem label='Serial Number' text={R.prop('_id', serial)} />
      <LineItem label='Name' text={R.prop('name', serial)} />
      <LineItem label='Email' text={R.prop('email', serial)} />
      <LineItem label='Source' text={R.prop('data_source', serial)} />
      <LineItem label='Max version' text={getMaxVersion(serial)} />
      <LineItem label='Free upgrade' text={getFreeUpgrade(serial)} />
      <LineItem label='Subscription End' text={getSubEnd(serial)} />
    </React.Fragment>
  )
}

SerialInfo.propTypes = {
  serial: PropTypes.object.isRequired
}

export default SerialInfo



// WEBPACK FOOTER //
// ./webAdmin/views/serialInfo.js